export const features = [
  {
    icon: 'ri-4k-line',
    title: '蓝光画质',
    desc: '全站资源支持1080P蓝光与4K超清画质，HDR色彩增强技术让每一帧都细腻逼真，带来影院级视觉享受。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速播引擎',
    desc: '自研P2P加速与全球CDN节点覆盖，点开即播零缓冲，拖动进度条秒级响应，告别卡顿等待。',
  },
  {
    icon: 'ri-film-line',
    title: '海量片库日更',
    desc: '收录超10万部影视资源，涵盖电影、电视剧、综艺、动漫全品类，编辑团队每日精选热门新片入库。',
  },
];

export const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20image%20featuring%20a%20mysterious%20figure%20silhouetted%20against%20a%20golden%20sunset%20sky%20with%20dramatic%20clouds%2C%20film%20grain%20texture%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20intense%20drama%20genre%20aesthetic%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20movie%20poster%20composition%20with%20clean%20dark%20background&width=800&height=1120&seq=card-01&orientation=portrait',
    title: '暗夜追凶',
    category: '悬疑 / 犯罪',
    rating: '9.2',
    year: '2026',
    tag: '热播中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20style%20with%20two%20figures%20standing%20under%20cherry%20blossom%20trees%20at%20sunset%2C%20soft%20warm%20golden%20backlight%2C%20dreamy%20atmosphere%2C%20film%20texture%2C%20amber%20and%20rose%20color%20palette%2C%20elegant%20composition%20with%20clean%20minimal%20background&width=800&height=1120&seq=card-02&orientation=portrait',
    title: '春日重逢',
    category: '爱情 / 剧情',
    rating: '8.7',
    year: '2026',
    tag: '新上架',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20style%20with%20a%20futuristic%20cityscape%20in%20neon%20lights%20and%20a%20lone%20figure%20on%20a%20rooftop%2C%20cyberpunk%20aesthetic%2C%20deep%20navy%20and%20warm%20gold%20accents%2C%20cinematic%20lighting%2C%20film%20grain%2C%20clean%20dark%20background%20with%20dramatic%20composition&width=800&height=1120&seq=card-03&orientation=portrait',
    title: '星际迷城',
    category: '科幻 / 冒险',
    rating: '8.9',
    year: '2026',
    tag: '推荐',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Martial%20arts%20action%20movie%20poster%20style%20with%20a%20dynamic%20figure%20in%20traditional%20Chinese%20robe%20mid-action%20pose%20against%20misty%20mountain%20landscape%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20ink%20wash%20painting%20influence%2C%20cinematic%20composition%20with%20clean%20background&width=800&height=1120&seq=card-04&orientation=portrait',
    title: '江湖风云录',
    category: '武侠 / 动作',
    rating: '9.0',
    year: '2026',
    tag: '热播中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20style%20with%20a%20young%20adventurer%20standing%20before%20a%20glowing%20magical%20portal%20in%20an%20enchanted%20forest%2C%20vibrant%20warm%20colors%2C%20golden%20sparkles%2C%20whimsical%20atmosphere%2C%20film%20texture%2C%20clean%20composition%20with%20dark%20borders&width=800&height=1120&seq=card-05&orientation=portrait',
    title: '秘境奇缘',
    category: '动画 / 奇幻',
    rating: '9.1',
    year: '2026',
    tag: '高分',
  },
];

export const rankingItems = [
  { rank: 1, title: '暗夜追凶', hot: '987万', trend: 'up', category: '悬疑' },
  { rank: 2, title: '江湖风云录', hot: '876万', trend: 'up', category: '武侠' },
  { rank: 3, title: '星际迷城', hot: '765万', trend: 'up', category: '科幻' },
  { rank: 4, title: '秘境奇缘', hot: '698万', trend: 'stable', category: '动画' },
  { rank: 5, title: '春日重逢', hot: '612万', trend: 'up', category: '爱情' },
  { rank: 6, title: '时光倒流的钟表店', hot: '589万', trend: 'down', category: '奇幻' },
];

export const topicItems = [
  { label: '悬疑推理', count: '2.8万讨论', icon: 'ri-search-eye-line' },
  { label: '国产剧热播', count: '5.1万讨论', icon: 'ri-tv-2-line' },
  { label: '高分电影', count: '3.4万讨论', icon: 'ri-star-line' },
  { label: '科幻巨制', count: '1.9万讨论', icon: 'ri-rocket-line' },
  { label: '武侠经典', count: '2.2万讨论', icon: 'ri-sword-line' },
  { label: '新片速递', count: '4.6万讨论', icon: 'ri-flashlight-line' },
  { label: '动画佳作', count: '1.5万讨论', icon: 'ri-emotion-line' },
  { label: '蓝光专区', count: '3.7万讨论', icon: 'ri-4k-line' },
  { label: '爱情电影', count: '2.1万讨论', icon: 'ri-heart-line' },
  { label: '喜剧爆笑', count: '2.9万讨论', icon: 'ri-emotion-happy-line' },
];

export const indexItems = [
  { label: '动作片', icon: 'ri-run-line', count: '3,286部' },
  { label: '喜剧片', icon: 'ri-emotion-happy-line', count: '2,154部' },
  { label: '爱情片', icon: 'ri-heart-line', count: '1,987部' },
  { label: '科幻片', icon: 'ri-rocket-line', count: '1,642部' },
  { label: '悬疑片', icon: 'ri-search-eye-line', count: '1,503部' },
  { label: '恐怖片', icon: 'ri-ghost-line', count: '1,218部' },
  { label: '动画片', icon: 'ri-emotion-line', count: '2,876部' },
  { label: '纪录片', icon: 'ri-camera-line', count: '1,089部' },
  { label: '战争片', icon: 'ri-shield-line', count: '756部' },
];

export const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20dramatic%20noir%20cityscape%20at%20night%2C%20rain-slicked%20streets%20reflecting%20neon%20signs%2C%20film%20noir%20detective%20aesthetic%2C%20deep%20crimson%20and%20gold%20accents%2C%20cinematic%20widescreen%20composition%2016:9%2C%20film%20grain%20texture%2C%20moody%20atmosphere&width=1400&height=600&seq=carousel-01&orientation=landscape',
    title: '悬疑烧脑特辑',
    desc: '10部反转神作让你猜不到结局',
    tag: '专题合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20cinematic%20banner%20with%20ancient%20Chinese%20temple%20on%20misty%20mountain%20peak%20at%20golden%20hour%2C%20silhouetted%20figure%20with%20flowing%20robe%2C%20warm%20amber%20lighting%2C%20ink%20wash%20painting%20style%2C%20widescreen%20composition%2C%20cinematic%20atmosphere&width=1400&height=600&seq=carousel-02&orientation=landscape',
    title: '武侠宇宙精选',
    desc: '从经典到新派，重温江湖快意恩仇',
    tag: '专题合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20banner%20with%20massive%20spaceship%20floating%20above%20alien%20planet%20surface%2C%20twin%20suns%20setting%20on%20horizon%2C%20warm%20golden%20and%20amber%20sky%2C%20epic%20scale%2C%20widescreen%20composition%2C%20film%20grain%2C%20cinematic%20lighting&width=1400&height=600&seq=carousel-03&orientation=landscape',
    title: '星际科幻盛典',
    desc: '年度必看科幻大片全收录',
    tag: '专题合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20cinematic%20banner%20with%20magical%20floating%20islands%20and%20waterfalls%20in%20a%20golden%20sunset%20sky%2C%20colorful%20hot%20air%20balloons%2C%20dreamy%20atmosphere%2C%20warm%20vibrant%20colors%2C%20widescreen%20composition%2C%20Ghibli-inspired%20aesthetic%2C%20soft%20lighting&width=1400&height=600&seq=carousel-04&orientation=landscape',
    title: '动画奇幻季',
    desc: '全家一起看的暖心动画精选',
    tag: '专题合集',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Classic%20film%20history%20cinematic%20banner%20with%20vintage%20movie%20theater%20interior%20illuminated%20by%20warm%20golden%20projector%20light%2C%20red%20velvet%20seats%2C%20art%20deco%20details%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20cinematic%20widescreen%2016:9%20composition&width=1400&height=600&seq=carousel-05&orientation=landscape',
    title: '高分经典回顾',
    desc: '豆瓣8.5+神作一次看过瘾',
    tag: '专题合集',
  },
];

export const updateItems = [
  { time: '07-31 14:30', title: '《暗夜追凶》大结局今日上线，谜底终揭晓', type: 'hot' },
  { time: '07-31 11:20', title: '蓝光专区新增50部4K修复经典影片', type: 'new' },
  { time: '07-30 20:15', title: '《江湖风云录》播放量突破8亿创平台纪录', type: 'hot' },
  { time: '07-30 16:40', title: '暑期动画专场《秘境奇缘》系列限时上线', type: 'new' },
  { time: '07-29 22:00', title: '平台极速播引擎完成全球节点扩容升级', type: 'info' },
  { time: '07-29 10:30', title: '《星际迷城》导演独家专访明日上线', type: 'new' },
  { time: '07-28 18:00', title: '纪录片频道新上《地球脉动》系列全三季', type: 'info' },
];

export const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20shot%20of%20film%20crew%20on%20a%20dramatic%20movie%20set%20with%20warm%20golden%20lighting%2C%20professional%20camera%20equipment%2C%20atmospheric%20studio%20environment%2C%20film%20production%20aesthetic%2C%20cinematic%20lighting%20with%20soft%20shadows&width=800&height=500&seq=media-01&orientation=landscape',
    title: '《暗夜追凶》幕后特辑：导演解读关键反转',
    duration: '12:38',
    views: '89万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20interview%20scene%20with%20two%20people%20in%20elegant%20studio%20setting%2C%20warm%20cinematic%20lighting%2C%20professional%20microphone%20setup%2C%20film%20posters%20in%20background%2C%20soft%20ambient%20atmosphere%2C%20documentary%20style%20photography&width=800&height=500&seq=media-02&orientation=landscape',
    title: '《江湖风云录》主演深度访谈',
    duration: '28:15',
    views: '156万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20award%20ceremony%20red%20carpet%20scene%20with%20golden%20decorations%20and%20warm%20spotlights%2C%20elegant%20atmosphere%2C%20prestigious%20film%20event%2C%20cinematic%20lighting%2C%20glamorous%20setting%2C%20professional%20photography%20style&width=800&height=500&seq=media-03&orientation=landscape',
    title: '年度影视盛典：最佳影片提名全解析',
    duration: '45:02',
    views: '234万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20critic%20discussion%20panel%20in%20a%20cozy%20modern%20screening%20room%20with%20movie%20screen%20showing%20warm%20golden%20images%2C%20comfortable%20seating%2C%20cinematic%20lighting%2C%20intellectual%20atmosphere%2C%20professional%20photography%20with%20soft%20ambient%20light&width=800&height=500&seq=media-04&orientation=landscape',
    title: '影评人圆桌：《星际迷城》深度解读',
    duration: '35:50',
    views: '67万',
  },
];

export const faqItems = [
  {
    q: '80s电影网需要注册才能观看吗？',
    a: '不需要。80s电影网所有影片免费在线观看，无需注册、无需登录，打开网站即可畅享蓝光画质极速播放体验。',
  },
  {
    q: '播放卡顿怎么办？如何选择合适的画质？',
    a: '平台采用极速播引擎与全球CDN加速，正常情况下点开即播。如遇卡顿，建议在播放器右下角切换至自适应模式，系统会根据您的网络自动匹配最佳清晰度。1080P蓝光推荐带宽10M以上，4K超清推荐50M以上。',
  },
  {
    q: '每日更新内容什么时候上架？',
    a: '编辑团队每日中午12:00和晚上20:00分两批次更新片库。热门电视剧跟播剧集在播出后2小时内上线，电影新片在院线下映后7-15个工作日内上线蓝光版本。',
  },
  {
    q: '支持哪些设备观看？可以投屏吗？',
    a: '80s电影网完美适配电脑、平板和手机浏览器，无需下载任何插件。同时支持DLNA和AirPlay无线投屏功能，您可以轻松将画面投射到电视大屏上，享受家庭影院体验。移动端App也已上架各大应用商店。',
  },
  {
    q: '影片资源是否正版？画质有保障吗？',
    a: '平台所有资源均经过严格版权审核与画质检测，确保合规性与视听品质。全站默认提供1080P蓝光画质，部分精选影片支持4K HDR，配合DTS环绕音效，打造沉浸式观影体验。',
  },
];

export const aboutContent = {
  title: '关于80s电影网',
  paragraphs: [
    '80s电影网创立于2018年，是国内领先的高清在线影视平台。我们致力于为广大影迷提供蓝光画质、极速播放、免费不卡的观影服务，让每一位用户都能随时随地畅享影院级的视听盛宴。',
    '平台收录超过10万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。自研极速播引擎搭配全球200+CDN节点，确保点开即播、拖动秒响应。编辑团队每日精选更新，让您不错过任何一部好片。',
    '我们相信，好的观影体验不应该有门槛。80s电影网坚持免费开放、无需注册、无广告打扰的原则，用技术和诚意连接每一位热爱影视的你。',
  ],
};

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20man%20with%20warm%20friendly%20expression%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '电影爱好者小王',
    time: '2小时前',
    content: '之前一直用别的站看，自从发现了80s电影网就彻底转到这里了。蓝光画质真的不是吹的，暗夜追凶那个夜景细节拉满，加载速度也快得离谱，拖动进度条完全不卡，太惊喜了！',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20smiling%20warmly%2C%20clean%20studio%20lighting%2C%20simple%20light%20neutral%20background%2C%20professional%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '追剧小达人',
    time: '5小时前',
    content: '每天中午和晚上准时蹲更新！江湖风云录全集追完了，画质和音效都很顶。关键是免费还不用注册，这个真的太良心了。已经推荐给身边所有朋友了，大家都说好。',
    likes: 518,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Asian%20man%20with%20glasses%2C%20warm%20professional%20expression%2C%20clean%20studio%20lighting%2C%20simple%20neutral%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '老影迷阿强',
    time: '昨天 22:30',
    content: '用80s电影网三年多了，看着它一点点变好。现在蓝光专区的4K修复老片子质量真的高，地球脉动系列全家一起看，投屏到电视上效果不输付费平台。希望继续保持，越来越好！',
    likes: 892,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20bright%20smile%2C%20clean%20studio%20lighting%2C%20simple%20warm%20neutral%20background%2C%20professional%20photography&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '科幻迷小雨',
    time: '昨天 18:15',
    content: '星际迷城真的太震撼了！在80s电影网看的蓝光版，特效细节都能看得很清楚。专题合集功能也很好用，把同类型的好片都整理在一起了，省得一个个去找，这个设计真的很贴心。',
    likes: 445,
  },
];

export const appContent = {
  title: '随时随地 · 畅享蓝光',
  desc: '80s电影网移动端App已上架各大应用商店。支持离线缓存、画中画播放、夜间模式，让观影不受时间地点限制。',
  features: ['蓝光画质', '离线下载', '画中画', '夜间模式', '极速播放', '投屏支持'],
};

export const contactContent = {
  title: '联系我们',
  desc: '如有资源推荐、内容合作或问题反馈，欢迎通过以下方式与我们取得联系。编辑团队将在24小时内回复您的留言。',
  email: 'service@80sdyw.com',
  workTime: '工作日 9:00 - 18:00',
};